'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _accessibilityUtils = require('./accessibilityUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * If the content overflows its container then allow toggling visibility.
 */
var MoreLess = function (_React$Component) {
	_inherits(MoreLess, _React$Component);

	function MoreLess(props) {
		_classCallCheck(this, MoreLess);

		var _this = _possibleConstructorReturn(this, (MoreLess.__proto__ || Object.getPrototypeOf(MoreLess)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onToggle = _this.onToggle.bind(_this);

		_this.state = {
			overflow: false,
			expanded: !!props.expanded
		};
		return _this;
	}

	_createClass(MoreLess, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(props) {
			if (props.expanded !== this.props.expanded && props.expanded !== this.state.expanded || props.children !== this.props.children) {
				// set expanded state when props change.
				this.setState({
					expanded: !!props.expanded
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.checkOverflow();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			this.checkOverflow();
		}
	}, {
		key: 'checkOverflow',
		value: function checkOverflow() {
			if (this.element) {
				var overflow = this.element.offsetHeight < this.element.scrollHeight || this.element.offsetWidth < this.element.scrollWidth;
				if (overflow !== this.state.overflow) {
					this.setState({
						overflow: overflow
					});
				}
			}
		}
	}, {
		key: 'onToggle',
		value: function onToggle(e) {
			e.preventDefault();
			this.setState({
				expanded: !this.state.expanded
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    className = _props.className,
			    more = _props.more,
			    less = _props.less;
			var _state = this.state,
			    expanded = _state.expanded,
			    overflow = _state.overflow;


			var label = expanded ? less || this.intl.formatMsg('Less') : more || this.intl.formatMsg('More');

			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('moreless', className) },
				_react2.default.createElement(
					'div',
					{
						ref: function ref(el) {
							_this2.element = el;
						},
						className: (0, _classnames2.default)('content', { expanded: expanded })
					},
					this.props.children,
					expanded && _react2.default.createElement(
						'a',
						{
							className: 'toggle',
							onClick: this.onToggle,
							onKeyPress: function onKeyPress(e) {
								return (0, _accessibilityUtils.OnActionKey)(e, function () {
									return _this2.onToggle(e);
								});
							},
							tabIndex: 0
						},
						label
					)
				),
				!expanded && overflow && _react2.default.createElement(
					'a',
					{
						className: 'toggle',
						onClick: this.onToggle,
						onKeyPress: function onKeyPress(e) {
							return (0, _accessibilityUtils.OnActionKey)(e, function () {
								return _this2.onToggle(e);
							});
						},
						tabIndex: 0
					},
					label
				)
			);
		}
	}]);

	return MoreLess;
}(_react2.default.Component);

MoreLess.propTypes = {
	more: _propTypes2.default.string,
	less: _propTypes2.default.string,
	expanded: _propTypes2.default.bool,
	className: _propTypes2.default.string
};

MoreLess.defaultProps = {
	expanded: false
};

var _default = (0, _reactIntl.injectIntl)(MoreLess);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(MoreLess, 'MoreLess', 'src/components/MoreLess.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/MoreLess.jsx');
}();

;